// api/services/projectService.js
import api from '../client';

export const projectService = {
  // Get all projects
  getAllProjects: async () => {
    try {
      const response = await api.get('/projects/');
      return response.data;
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  },

  // Get a specific project by ID
  getProject: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching project ${projectId}:`, error);
      throw error;
    }
  },

  // Create a new project
  createProject: async (projectData) => {
    try {
      // Use FormData for file uploads
      const formData = new FormData();
      
      // Add text fields
      formData.append('name', projectData.name);
      formData.append('url_name', projectData.url_name);

      // Add default_export_format with fallback to 'docx'
      formData.append('default_export_format', projectData.default_export_format || 'docx');

      if (projectData.description) {
        formData.append('description', projectData.description);
      }
      formData.append('main_color', projectData.main_color);
      
      // Add workspace_id if present
      if (projectData.workspace_id) {
        formData.append('workspace_id', projectData.workspace_id);
      }
      
      const response = await api.post('/projects/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return response.data;
    } catch (error) {
      console.error('Error creating project:', error);
      throw error;
    }
  },

  // Update an existing project
  updateProject: async (projectId, projectData) => {
    try {
      // Regular update
      const response = await api.patch(
        `/projects/${projectId}/`,
        projectData
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating project ${projectId}:`, error);
      throw error;
    }
  },

  // Delete a project
  deleteProject: async (projectId) => {
    try {
      await api.delete(`/projects/${projectId}/`);
      return true;
    } catch (error) {
      console.error(`Error deleting project ${projectId}:`, error);
      throw error;
    }
  },

  // Get general available settings
  getGeneralSettings: async () => {
    try {
      const response = await api.get('/settings/');
      return response.data;
    } catch (error) {
      console.error('Error fetching general settings:', error);
      throw error;
    }
  },
};

export default projectService;